const helper = {
  getAge: (dateString) => {
    if (!dateString) return 0;
    let today = new Date();
    let birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  },
  formatDate: (dt) => {
    //pass dt as "yyyy/mm/dd"
    // get output as "mm/dd/yyyy"
    if (!dt) return;

    let x = dt.split("-");
    let formatedDt = [x[1], x[2], x[0]].join("/");

    return formatedDt;
  },
};

export default helper;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/helper.js